import React from 'react';

const Vue_Templates = () => {
  return (
    <div>
      <h1>Vue_Templates Component</h1>
      <p>This is the Vue_Templates tutorial page.</p>
    </div>
  );
}

export default Vue_Templates;
